/* ── Scroll reveal ─────────────────────────────────────────── */
(function () {
  const io = new IntersectionObserver(
    entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('v'); io.unobserve(e.target); }
    }),
    { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
  );
  document.querySelectorAll('.r').forEach(el => io.observe(el));
})();

/* ── FAQ accordion ─────────────────────────────────────────── */
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

/* ── Gallery thumbnails ────────────────────────────────────── */
document.querySelectorAll('.gallery-thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const imgSrc = thumb.dataset.img;
    if (imgSrc) {
      const mainImg = document.getElementById('main-gallery-img');
      if (mainImg) mainImg.src = imgSrc;
    }
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

/* ── Product tabs ──────────────────────────────────────────── */
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const target = btn.dataset.tab;
    document.querySelectorAll('.tab-btn').forEach(b => {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    btn.setAttribute('aria-selected', 'true');
    const pane = document.getElementById('tab-' + target);
    if (pane) pane.classList.add('active');
  });
});

/* ── Quantity control ──────────────────────────────────────── */
(function () {
  const upBtn = document.getElementById('qty-up');
  const downBtn = document.getElementById('qty-down');
  const valEl = document.getElementById('qty-val');
  const qtyInput = document.getElementById('form-quantity');
  if (!upBtn || !downBtn || !valEl) return;
  let qty = 1;
  function setQty(n) {
    qty = n;
    valEl.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }
  upBtn.addEventListener('click', () => setQty(Math.min(qty + 1, 10)));
  downBtn.addEventListener('click', () => setQty(Math.max(qty - 1, 1)));
})();

/* ── Product page variant selector ────────────────────────── */
(function () {
  const packs = document.querySelectorAll('.prod-pack');
  if (!packs.length) return;

  const variantInput = document.getElementById('variant-id');
  const priceEl = document.getElementById('selected-price');
  const compareEl = document.getElementById('selected-compare');
  const atcBtn = document.getElementById('add-to-cart');
  const stickyLabel = document.querySelector('.sticky-bar-price span');
  const stickyPrice = document.querySelector('.sticky-bar-price');

  function updateUI(pack) {
    const variantId = pack.dataset.variantId;
    const price = pack.dataset.price;
    const compare = pack.dataset.compare;
    const label = pack.querySelector('.pack-label')?.textContent || '';

    if (variantInput) variantInput.value = variantId;
    if (priceEl) priceEl.textContent = price;
    if (compareEl && compare) compareEl.textContent = compare;
    if (atcBtn) {
      const btnText = atcBtn.querySelector('.atc-text');
      if (btnText) btnText.textContent = 'Add to Cart — ' + price;
    }
    if (stickyLabel) stickyLabel.textContent = label;
  }

  packs.forEach(pack => {
    pack.addEventListener('click', () => {
      packs.forEach(p => { p.classList.remove('selected'); p.setAttribute('aria-pressed', 'false'); });
      pack.classList.add('selected');
      pack.setAttribute('aria-pressed', 'true');
      updateUI(pack);
    });
  });

  const selected = document.querySelector('.prod-pack.selected');
  if (selected) updateUI(selected);
})();

/* ── Homepage pack selector ────────────────────────────────── */
(function () {
  const rows = document.querySelectorAll('.pack-row');
  const variantInput = document.getElementById('packs-variant-id');
  if (!rows.length) return;

  rows.forEach(row => {
    row.addEventListener('click', () => {
      rows.forEach(r => { r.classList.remove('selected'); r.setAttribute('aria-pressed', 'false'); });
      row.classList.add('selected');
      row.setAttribute('aria-pressed', 'true');
      if (variantInput && row.dataset.variantId) {
        variantInput.value = row.dataset.variantId;
      }
    });
  });
})();

/* ── Add to Cart AJAX (product page only) ──────────────────── */
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (_) {}
  }

  form.addEventListener('submit', async e => {
    /* Let name="checkout" buttons go to Shopify checkout natively */
    if (e.submitter && e.submitter.name === 'checkout') return;

    e.preventDefault();
    const variantId = form.querySelector('[name="id"]')?.value;
    const quantity = parseInt(document.getElementById('qty-val')?.textContent || '1');
    const btn = document.getElementById('add-to-cart');
    if (!variantId || !btn) return;

    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="atc-text">Adding...</span>';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity }] })
      });

      if (!res.ok) throw new Error('add failed');

      await updateCartCount();
      btn.innerHTML = '<span class="atc-text">Added to Cart!</span>';
      setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
    } catch (_) {
      btn.innerHTML = '<span class="atc-text">Try Again</span>';
      setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
    }
  });
})();

/* ── Sticky bar visibility ─────────────────────────────────── */
(function () {
  const prodSection = document.querySelector('.product-main');
  const stickyBar = document.getElementById('sticky-bar');
  if (!prodSection || !stickyBar) return;

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      stickyBar.style.display = e.isIntersecting ? 'none' : 'block';
    });
  }, { threshold: 0.05 });
  obs.observe(prodSection);
})();
